import { useEffect, useState, useRef } from 'react';

const clients = [
  {
    name: 'Terra Drone',
    logo: 'https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/n9gzcon3_Logo-Terra-Drone_Logo-Normal-Complete-1-1024x1024.png',
    industry: 'Drone Services',
  },
  {
    name: 'PG JYX Manufacture',
    logo: 'https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/fbz1mn92_PG%20JYX%20logo.png',
    industry: 'Manufacturing',
  },
  {
    name: 'JPC JYX Development',
    logo: 'https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/fbz1mn92_PG%20JYX%20logo.png',
    industry: 'Property Development',
  },
  {
    name: 'Amazing Secret',
    logo: 'https://customer-assets.emergentagent.com/job_651541d7-5e6b-42ae-bbbb-a15776d2b14a/artifacts/jo1zupy2_AS%20logo.png',
    industry: 'E-Commerce',
  },
];

const industries = [
  'Manufacturing',
  'Drone Services',
  'E-Commerce',
  'Property Development',
];

export default function ClientsSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="clients"
      ref={sectionRef}
      data-testid="clients-section"
      className="py-24 sm:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#F5A623] text-xs tracking-[0.2em] uppercase font-semibold mb-4">
            Our Clients
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-[#1A1A2E]">
            Trusted by Leading Organisations
          </h2>
        </div>

        {/* Clients Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {clients.map((client, index) => (
            <div
              key={client.name}
              data-testid={`client-card-${index}`}
              className={`glass-card-light rounded-2xl p-6 flex flex-col items-center justify-center min-h-[160px] reveal ${
                isVisible ? 'visible' : ''
              }`}
              style={{ transitionDelay: `${index * 50}ms` }}
            >
              {client.logo ? (
                <img
                  src={client.logo}
                  alt={client.name}
                  loading="lazy"
                  decoding="async"
                  className="h-16 w-auto object-contain mb-3"
                />
              ) : (
                <div className="w-16 h-16 rounded-xl bg-[#193E82]/10 flex items-center justify-center mb-3">
                  <span className="text-[#193E82] text-xl font-bold">
                    {client.name.split(' ').map(w => w[0]).join('').slice(0, 2)}
                  </span>
                </div>
              )}
              <p className="text-sm font-semibold text-[#1A1A2E] text-center">{client.name}</p>
              <p className="text-xs text-[#5A5A5A]">{client.industry}</p>
            </div>
          ))}
        </div>

        {/* Industry Tags */}
        <div className="flex flex-wrap justify-center gap-3">
          {industries.map((industry) => (
            <span
              key={industry}
              className="px-4 py-2 text-sm font-medium text-[#193E82] bg-[#193E82]/10 rounded-full"
            >
              {industry}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
